<template>
  <div class="loginwindow transitionBody">
    <div class="login-tips-title">{{ $t('登录') }}</div>
    <div class="login-tips-desc">{{ $t('更多新玩法等你来体验') }}!</div>
    <div data-v-60ee706e="" class="lginner"><img data-v-60ee706e=""
                                                 src=""
                                                 alt="" class="gbline" @click="back">
      <div data-v-60ee706e="" class="LoginSquare">
        <div data-v-60ee706e="" class="inputline"><input v-model="name" data-v-60ee706e="" type="text" maxlength="16"
                                                         :placeholder="$t('请输入手机号或用户名')">
          <div data-v-60ee706e=""></div>
        </div>
        <div data-v-60ee706e="" class="inputline">
          <div data-v-60ee706e=""></div>
          <input v-model="password" data-v-60ee706e="" maxlength="16" :placeholder="$t('请输入密码')"
                 :type="show1?'text':'password'">
          <img @click="show1=!show1" v-if="!show1" data-v-65d98e59=""
               src="/static/image/new/login/eye-icon.png"
               class="eye"
          />
          <img v-else @click="show1=!show1" data-v-65d98e59="" src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEAAAAAoCAMAAAB5EAzbAAAAn1BMVEUAAAAdJUgqKkkdJUcdJUgdJEcYKUQdJUgcJUgeJEgdIUceIE0cJUgcJUgdJUgdJUccJEgdJUgdJUgcJUgdJEgdJUgcJUgdJEgcJUgdJUgdJEgbI0gdJUkcJUceJUkfI0kdHU0dJUgdJEgcJUgdJUgdJEccJEgcJUkcIkYcJUgcJUccJUgcJEkdJUgcJUgdJEgdJkkfJ0YgKEgcJUgdJUiVJwGxAAAANHRSTlMA+Abv3EkM69AzHhC+drCphmbk4MO6a5OKcU9APi0oGAjyyqylm1s4JLWhj4Bf19TMISBSdyDvIwAAAe9JREFUSMellOmyojAQhU9YBRQRccf1uutdp9//2cZhklRCUJT7/aHqpOnkdHc1DMLYT9/2hmy9x+k6DlGL9UH/2Kx02WsVcgu1BPSfni4PuRw8l8C8y+HyAnXI0JkqukZaA+OxsSoOpLF6PJsHKxVfcMlf4QlGPHpsSkn1lfkcKkcebXtCidZUwEKozGdFhGsTDZZQiMuGJ1zoQuEnu1maAZ5fmHMrSu5cdt0bu0ufCwclaFqUKrVwqLD3STpmD62LnItAHGchNzzM6A6bCbf6vRFSBK/4ShvBmdEDWPfAn89dAmiTJAlOVEs7H5FkBGDhUGOcsDD9Rg3ZemL87/j2nVaWfTn96mPWgyQo27DjibuwIFjmvV055EOb33f1KE0CVHDsaDmG9/4fTHGXXC3XBJKeMm0zPGSudL0jxD9SYh3UsrdJwKt4YLKtczxBuCGBW1Q4lTMWmUs+DGGKsWzWUR3lk7Gv3AG72TrNjAxd4nxZmMj7Leh4suRbI/VWHF0hlsVnVL4mU1prvEG828eau/lBiYQUjO5Eff4fzlQwNSKYNtoWSgRrvrq9LSPWds12k4YZsOwM0v61SByhgjFpdPAqO9IY41WS375gSho5XmXlk0IfrzMkhT0acFa3dyOuTG6JhhzHLdtuJd94wF9aYcKHBwtsvgAAAABJRU5ErkJggg==" class="eye">
        </div>
        <div data-v-60ee706e="" id="captcha" style="position: relative; top: 10px;"></div>
        <div data-v-60ee706e="" class="inputline" style="display: none;">
          <input data-v-60ee706e="" type="text"
                 :placeholder="$t('请输入验证码')">
          <img data-v-60ee706e=""
               src="https://ngwsapi1.jmzswl.com/src/index/get_img_code?username=" class="yzm"></div>
        <div data-v-60ee706e="" class="oplines">
          <div data-v-60ee706e="" class="ltbox">
            <van-switch size="16" v-model="auto" inactive-color="#dcdee0" />
            <span style="margin-left: .15rem;">{{$t('自动登录')}}</span>
          </div>
          <!--                  <div data-v-60ee706e="" class="rtbox" @click="login2">{{ $t('游戏试玩') }}</div>-->
          <div data-v-60ee706e="" @click="kefu" style="color: #4B5BF1;">{{ $t('忘记密码') }}</div>
        </div>
        <div data-v-60ee706e="" class="confirm"><span @click="login" data-v-60ee706e="" id="login" class="sumbtns" :class="{sbac:isOk}">{{ $t('登录账户') }}</span>
        </div>
        <div data-v-60ee706e="" class="botline">
          <div data-v-60ee706e="" @click="kefu">{{ $t('联系客服') }}</div>
          <div data-v-60ee706e="" @click="go('/reg2')">{{ $t('注册账户') }}</div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import {translateText} from "../common/utils";

export default {
  name: 'login',
  data() {
    return {
      show1:false,
      auto:false,
      registerInfo: {},
      loginInfo: {},
      imgLis: ['2PYL', '6AQ5', '8PHD', '21I7', '69HM', 'ACWA', 'DUZ7', 'IY98', 'K647', 'M52T', 'NY52', 'NZFA', 'SN76', 'SP4D', 'VAEO', 'YFQM', 'ZZU5', '7GQT', 'LFW3', 'NU2T', 'UAE3'],
      index: 0,
      infoType: 0, //0 是登陆 1是注册
      psw1: true,
      psw2: true,
      psw3: true,
      pid: '',
      name:'',
      password:'',
      isOk:false,
      url: ''
    };
  },
  created() {
    let that = this;
    var query = that.$route.query;
    if (query.type) {
      that.infoType = query.type;
    }
    if (query.pid) {
      that.pid = query.pid;
    }
    that.changIndex();
    this.getservicerurl()
  },
  watch:{
    name(){
      this.get_test()
    },
    password(){
      this.get_test()
    }
  },
  methods: {
    async showTost(type = 0, title) {
      const message = await translateText([title]);
      this.$parent.showTost(type, message[0]);
    },
    getservicerurl() {
      let that = this;
      that.$apiFun.post('/api/getservicerurl', {}).then(res => {
        if (res.code != 200) {
          that.showTost(0, res.message);
        }
        if (res.code == 200) {
          that.url = res.data.url;
        }
      });
    },
    kefu(){
      this.$parent.openKefu();
      // window.open(this.url, '_blank');
    },
    get_test(){
      if(this.name&&this.password){
        this.isOk=true
      }else{
        this.isOk=false
      }
    },
    back(){
      window.history.go(-1)
    },
    go(s){
      this.$router.push(s)
    },
    changPsw(name) {
      this[name] = !this[name];
    },
    changInfoType(type) {
      if(type==1){
        this.$router.push('reg')
        return
      }
      let that = this;
      if (that.infoType == type) {
        return;
      }
      that.infoType = type;
      that.changIndex();
      that.loginInfo = {};
      that.registerInfo = {};
      this.psw1 = true;
      this.psw2 = true;
      this.psw3 = true;
    },
    changIndex() {
      this.index = parseInt(20 * Math.random());
    },
    register() {
      let that = this;

      let info = that.registerInfo;
      console.log(info);
      if (!info.name || info.name.length < 6) {
        that.showTost(0, ' 用户名长度6~16位，以字母或数字组合！');
        return;
      }
      if (!info.password || info.password.length < 6) {
        that.showTost(0, '请输入正确的密码长度，最少6位！');
        return;
      }
      // if (!info.confirmPass || info.confirmPass != info.password) {
      //   that.$parent.showTost(0, '两次密码不一致！');
      //   return;
      // }
      // if (!info.realname || info.realname.length < 2) {
      //   that.$parent.showTost(0, '请输入您的真实姓名!');
      //   return;
      // }

      // if (!info.paypassword || info.paypassword.length < 6) {
      //   that.$parent.showTost(0, '请输入正确的支付密码长度，最少6位！');
      //   return;
      // }
      // let code = that.registerInfo.code;
      // if (!code) {
      //   that.$parent.showTost(0, '请输入验证码！');

      //   return;
      // }
      // if (code.toUpperCase() != that.imgLis[that.index]) {
      //   that.$parent.showTost(0, '验证码错误！');
      //   that.registerInfo.code = null;
      //   that.changIndex();
      //   return;
      // }
      that.$parent.showLoading();
      if (that.pid) {
        info.pid = that.pid;
      }
      console.log(info);
      that.$apiFun.register(info).then(res => {
        that.showTost(1, res.message);
        if (res.code == 200) {
          localStorage.setItem('token', res.data.api_token);
          sessionStorage.setItem('token', res.data.api_token);
          that.$store.commit('changToken');
          that.$parent.getUserInfo();
          that.$parent.openDaoTime();


          that.$parent.goNav('/home');
        }
        that.$parent.hideLoading();
      });
    },
    login() {
      let that = this;
      let info = {
        name:this.name,
        password:this.password
      };
      if (!info.name || !info.password) {
        // that.$parent.showTost(0, '请输入您的账号和密码！');
        return;
      }
      // let code = that.loginInfo.code;
      // if (!code) {
      //   that.$parent.showTost(0, '请输入验证码！');

      //   return;
      // }
      // if (code.toUpperCase() != that.imgLis[that.index]) {
      //   that.$parent.showTost(0, '验证码错误！');
      //   that.loginInfo.code = null;
      //   that.changIndex();
      //   return;
      // }

      that.$parent.showLoading();
      that.$apiFun.login(info).then(res => {
        if (res.code !== 200) {
          that.showTost(0, res.message);
          that.$parent.hideLoading();
        }
        if (res.code === 200) {
          localStorage.setItem('token', res.data.api_token);
          that.$store.commit('changToken');
          that.$parent.getUserInfo();
          that.$parent.openDaoTime();

          // that.$parent.goNav('/');
          this.$router.replace({ path: '/home' });
        }
        that.$parent.hideLoading();
      });
    },
    login2(){
      let that = this;
      let info = {
        name:"游客试玩123456",
        password:123456
      };
      that.$parent.showLoading();
      that.$apiFun.login(info).then(res => {
        if (res.code === 200) {
          localStorage.setItem('token', res.data.api_token);
          that.$store.commit('changToken');
          that.$parent.getUserInfo();
          that.$parent.openDaoTime();

          that.$parent.goNav('/home');
        }
        that.$parent.hideLoading();
      }).catch(err=>{
        that.$parent.hideLoading();
      })
    }
  },
  mounted() {
    let that = this;
  },
  updated() {
    let that = this;
  },
  beforeDestroy() {},
};
</script>

<style lang="scss" scoped>
.loginwindow {
  width:100%;
  background-color:#000;
  background-image:url(/static/image/new/login/login-bg.png);
  background-repeat:no-repeat;
  background-size:100% auto;
  padding: 6rem .4rem 0;
  font-family: PingFang SC;
  color: #fff;
  position: fixed;
  top: 0;
  left: 0;
  bottom: 0;

  input:-webkit-autofill,
  input:-webkit-autofill:hover,
  input:-webkit-autofill:focus {
    -webkit-box-shadow: 0 0 0px 1000px #1B1B1B inset !important;
    box-shadow: 0 0 0px 1000px #1B1B1B inset !important;
    -webkit-text-fill-color: #fff !important; /* 保持文本颜色继承 */
    transition: background-color 9999s ease-out 0s !important;
  }
  .login-tips-title {
    font-family: HYYakuHei;
    font-size: 0.64rem;
    text-align: left;
  }
  .login-tips-desc {
    font-size: 0.37rem;
    color: #CECECE;
    margin: .24rem 0 .7rem;
  }
}

.loginwindow .lginner[data-v-60ee706e] {
    width:100%;
    box-sizing:border-box;
    border-radius: 0.53rem;
    margin: 0 auto;
    display: flex;
    justify-content: center;
    padding: .53rem;
    background: rgba(255, 255, 255, .1);
    border: .003rem solid rgba(255, 255, 255, .1);

}
.loginwindow .lginner .gbline[data-v-60ee706e] {
  position:fixed;
  right:.26667rem;
  top:.26667rem;

  width:1.06667rem
}
.loginwindow .LoginSquare .inputline[data-v-60ee706e] {
  float:left;
  width:100%;
  height:1.31rem;
  background-color: rgba(27, 27, 27, 0.90);
  border-radius:.26667rem;
  box-sizing:border-box;
  margin-top:.27rem;
  position:relative;
  display: flex;
  align-items: center;
  border: .003rem solid rgba(255, 255, 255, .1);
  &:first-child {
    margin-top: 0;
  }
}
.loginwindow .LoginSquare .inputline input[data-v-60ee706e] {
  width:6.66667rem;
  // height:100%;
  padding-left:.4rem;
  color:#fff !important;
  text-align:left;
  line-height:1.12rem;
  font-size:.37333rem;
  border:none !important;
  outline:none !important;
  z-index:2;
  border-radius:.26667rem;
  background: rgba(27, 27, 27, 0.90) !important;
  &::placeholder {
    color: #bbb;
  }
}
.loginwindow .LoginSquare .inputline div[data-v-60ee706e] {
  width:50%;
  height:1.31rem;
  float:left;
  color:red;
  position:absolute;
  z-index:1;
  right:0;
  border-radius:.26667rem
}
.loginwindow .LoginSquare .inputline .eye{
  width:0.48rem;
  margin-left:.4rem;
  position: relative;
  z-index: 10;
}
.loginwindow .LoginSquare .inputline .yzm[data-v-60ee706e] {
  width:1.89333rem;
  height:.66667rem;
  border:.02667rem solid #e3e4ea;
  float:right;
  margin-top:.21333rem;
  margin-right:.4rem;
  right:0;
  position:absolute;
  z-index:3
}
.loginwindow .LoginSquare .confirm[data-v-60ee706e] {
  display:flex;
  justify-content:center;
}
.loginwindow .LoginSquare .confirm .sumbtns[data-v-60ee706e] {
  height:1.23rem;
  color:#fff;
  width: 100%;
  border-radius:.8rem;
  background: linear-gradient(to bottom, #4B5BF1 40%, #B5BBF8);
  margin-top:.53rem;
  font-size: 0.43rem;
  font-weight:700;
  text-align: center;
  line-height: 1.23rem;
  overflow: hidden;
}
.loginwindow .LoginSquare .confirm .sbac[data-v-60ee706e] {
  opacity:1
}
.loginwindow .LoginSquare .botline[data-v-60ee706e] {
  width:100%;
  display:flex;
  justify-content: space-between;
  margin-top:.27rem
}
.loginwindow .LoginSquare .botline div[data-v-60ee706e] {
  color:#bbb;
  font-size:.37333rem;
  text-align: center;
  font-size: .32rem;
}
.loginwindow .LoginSquare .oplines[data-v-60ee706e] {
  display:-webkit-box;
  display:-webkit-flex;
  display:-ms-flexbox;
  display:flex;
  -webkit-box-pack:justify;
  -webkit-justify-content:space-between;
  -ms-flex-pack:justify;
  justify-content:space-between;
  width:100%;
  padding-top:.43rem;
  color:#bbb;
  font-size: 0.32rem;
  font-family:PingFang SC;
  font-weight:500;
}
  .van-switch--on {
    background: linear-gradient(to bottom, #4B5BF1 40%, #B5BBF8) !important;
    border-color: #4B5BF1 !important;
  }
.loginwindow .LoginSquare .oplines>div .van-checkbox__icon[data-v-60ee706e] {
  font-size:.34667rem;
  height:.34667rem;
  line-height:.34667rem
}
.loginwindow .LoginSquare .oplines>div .van-icon[data-v-60ee706e] {
  width:.34667rem;
  height:.34667rem;
  border-radius:.08rem
}
.loginwindow .LoginSquare .oplines>div .van-checkbox__label[data-v-60ee706e] {
  height:.34667rem;
  line-height:.34667rem
}
.loginwindow .LoginSquare .oplines>div .van-checkbox__icon--checked .van-icon[data-v-60ee706e] {
  background-color:#1989fa
}
.loginwindow .LoginSquare .oplines .ltbox[data-v-60ee706e] {
  display:-webkit-box;
  display:-webkit-flex;
  display:-ms-flexbox;
  display:flex;
  -webkit-box-align:center;
  -webkit-align-items:center;
  -ms-flex-align:center;
  align-items:center
}
.loginwindow .LoginSquare .oplines .ltbox>img[data-v-60ee706e] {
  margin-right:.08rem;
  width:.85333rem;
  height:.48rem
}
</style>



// WEBPACK FOOTER //
// src/components/login.vue